export const FETCH_CLIENTS_SOCIETIES = 'clientSociety/FETCH_CLIENTS_SOCIETIES';
export const PUT_CLIENT_SOCIETY = 'clientSociety/PUT_CLIENT_SOCIETY';
